/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import EditAction from './EditAction/index'
import EditOrAdd from './EditOrAdd/index'
import Fields from './Fields/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/Addresses/Content/Address/Edit/Content"
  
}) {
  return (<React.Fragment
>
<EditOrAdd
  viewPath={`${viewPath}/EditOrAdd`}
/>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 paddingTop={0}
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 height="auto"
 overflowX="hidden"
 width={400}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Edit Address"
/>
<CloseAction
{...childProps}
  viewPath={`${viewPath}/CloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<Fields
{...childProps}
  viewPath={`${viewPath}/Fields`}
/>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<EditAction
{...childProps}
  viewPath={`${viewPath}/EditAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}